export default __webpack_public_path__ + "static/media/SUTER-BNB.fc922b46.svg";